import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { IApiError } from '../../../react-core/Core/ApiError';
import { DrawdownModel } from '../../Models/Models/QuoteAndApplyBase/Shared/DrawdownModel';
import { DrawdownErrors } from '../../Validation/Errors/Drawdown/DrawdownErrors';

declare var IS_RUNNING_IN_APP_POOL;

export class DrawdownRequestClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(requestId: number, drawdownModel: DrawdownModel, isITFC: boolean, subaccountHierarchyId: string, instructionOwnerHierarchyId: string): Promise<DrawdownModel, IApiError<DrawdownErrors>[]> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Drawdown/DrawdownRequest/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { requestId: requestId, drawdownModel: drawdownModel, isITFC: isITFC, subaccountHierarchyId: subaccountHierarchyId, instructionOwnerHierarchyId: instructionOwnerHierarchyId }

    return AjaxWrapper.post<DrawdownModel, IApiError<DrawdownErrors>[]>(url, data);
  }
}

